module.exports = __webpack_public_path__ + "img/CRT_Weapon-Wand-02.5fbfd404.png";